var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgType = function SvgType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "type_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".type_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5H1.5c-.6 0-1-.4-1-1v-16c0-.6.4-1 1-1h15c.6 0 1 .4 1 1v10M15.7 22.3l-4.2 1.2 1.2-4.2 7.2-7.2c.8-.8 2.2-.8 3 0s.8 2.2 0 3zM19 13l3 3M12.7 19.3l3 3M6 4.5h7M4 7.5h9M4 10.5h9M4 13.5h6.5",
    className: "type_svg__st0"
  })));
};
export default SvgType;